export const isValueValid = (value: any, allowMissing = false) => {
  if (value === null) return false;

  if (typeof value === "boolean") return true;

  if (typeof value === "number" && !isNaN(value)) return true;

  return (
    value &&
    value !== "NA" &&
    value !== "Not Applicable" &&
    value !== "NaN" &&
    (allowMissing || !value.toLowerCase().includes("missing")) &&
    !value.toLowerCase().includes("not reported") &&
    !value.toLowerCase().includes("pending") &&
    !value.toLowerCase().includes("not required") &&
    !value.toLowerCase().includes("not done") &&
    !value.toLowerCase().includes("not enrolled") &&
    value !== "-"
  );
};

export const formatValue = (x: any) =>
  isNaN(x) ? "N/A" : x.toLocaleString("en");

export const pluralize = (value: any, word: any) => {
  return value === 1 ? word : word + "s";
};
